<template lang="">
<Layout class="bg-white">
    <PageHeader :title="title"></PageHeader>
    <div class="mb-5">
        <v-row v-if="showContentLoader">
            <v-col v-for="(n, index) in 4" :key="index + 4" lg="">
                <SkeletonLoader type="divider, image" />
            </v-col>
            <v-col cols="12">
                <SkeletonLoader type="divider, image" />
            </v-col>
        </v-row>

        <div v-else>
            <b-row class="mt-5">
                <b-col lg="" sm="6">
                    <b-card class="cod-card insight-card">
                        <v-icon size="55" class="my-1">
                            $vuetify.icons.ordersDeliverd
                        </v-icon>
                        <div class="cod-wrapper">
                            <p class="cod-number my-lg-1">
                                {{items.sea_requests_count}}
                            </p>
                            <p class="cod-content">
                                <span>{{ $t("Sea shipment Count") }}</span>
                                <span>{{ $t("") }}</span>
                            </p>
                        </div>
                    </b-card>
                </b-col>
                <b-col lg="" sm="6">
                    <b-card class="cod-card insight-card">
                        <v-icon size="55" class="my-1">
                            $vuetify.icons.ordersDeliverd
                        </v-icon>
                        <div class="cod-wrapper">
                            <p class="cod-number my-lg-1">
                                {{items.air_requests_count}}
                            </p>
                            <p class="cod-content">
                                <span>{{ $t(" Air shipment Count") }}</span>
                                <span>{{ $t("") }}</span>
                            </p>
                        </div>
                    </b-card>
                </b-col>
                <b-col lg="" sm="6">
                    <b-card class="cod-card insight-card">
                        <v-icon size="55" class="my-1">
                            $vuetify.icons.ordersDeliverd
                        </v-icon>
                        <div class="cod-wrapper">
                            <p class="cod-number my-lg-1">
                                {{items.current_month_sea_requests_count}}
                            </p>
                            <p class="cod-content">
                                <span>{{ $t("Sea shipment Count") }}</span>
                                <span>{{ $t("This Month") }}</span>
                            </p>
                        </div>
                    </b-card>
                </b-col>
                <b-col lg="" sm="6">
                    <b-card class="cod-card insight-card">
                        <v-icon size="55" class="my-1">
                            $vuetify.icons.ordersDeliverd
                        </v-icon>
                        <div class="cod-wrapper">
                            <p class="cod-number my-lg-1">
                                {{items.current_month_air_requests_count}}
                            </p>
                            <p class="cod-content">
                                <span>{{ $t(" Air shipment Count") }}</span>
                                <span>{{ $t("This Month") }}</span>
                            </p>
                        </div>
                    </b-card>
                </b-col>
                <div class="line-wrap mb-4">
                    <span>Year Insights</span>
                    <hr />
                </div>

                <b-card class="py-0 px-3 mt-5">
                    <div class="pr-lg-5" id="yearInsights">
                        <apexchart type="bar" height="350" :series="yearInsights.series" :options="yearInsights.chartOptions"></apexchart>
                    </div>
                </b-card>
            </b-row>
        </div>
    </div>

</Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  Freight
} from "@/services/westore/entities";

import SkeletonLoader from "../../../components/skeletons/skeleton-loader.vue";
import {
  yearInsights
} from "./yearInsights";

export default {
  page: {
    title: "Insights",
    meta: [{
      name: "description",
      content: appConfig.description,
    },],
  },
  components: {
    Layout,
    PageHeader,
    SkeletonLoader,
  },
  data() {
    return {
      title: "Freight Insights",
      items: {},
      showContentLoader: true,
      yearInsights: yearInsights,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.showContentLoader = true;

      try {
        let resp = await Freight.getInsights();
        this.items = resp;

        if (this.items.year_insights) {
          const months = Object.keys(this.items.year_insights);
          // Sort months based on their numeric values
          const sortedMonths = months.sort((a, b) => Number(a) - Number(b));
          const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
          ];

          const seaData = [];
          const airData = [];

          sortedMonths.forEach(month => {
            seaData.push(this.items.year_insights[month].Sea);
            airData.push(this.items.year_insights[month].Air);
          });

          this.yearInsights.series[0].data = seaData;
          this.yearInsights.series[1].data = airData;

          this.yearInsights.chartOptions.xaxis.categories = sortedMonths.map(month => monthNames[Number(month) - 1]);
        } else {
          console.warn("No year_insights data found in the response.");
        }
        this.showContentLoader = false;
      } catch (error) {
        console.error("Error", error);
        this.showContentLoader = false;
      }
    },

  }
}
</script>

<style lang="scss">
.insight-card{
  svg rect {
      fill: #101820 !important;
    }
}
</style>